/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains required categories for web
 */
export const requiredCategoriesContextKey = "requiredCategories";
